import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { OFFICE_DOCUMENTS_QUERY_KEY } from "../useOfficeDocumentsQuery";

export const useInvalidateOfficeDocuments = () => {
  const queryClient = useQueryClient();

  return useCallback(
    async () => {
      await queryClient.invalidateQueries({
        queryKey: [OFFICE_DOCUMENTS_QUERY_KEY]
      });
    },
    [queryClient]
  );
};
